const services = [
  {
    icon: "ri-server-line",
    title: "Infraestrutura, Servidores e HCI",
    description:
      "Modernização da infraestrutura de TI com servidores, convergência, hiperconvergência, virtualização, orquestração, switches e access points para elevar desempenho, escalabilidade e segurança.",
    tags: ["Servidores", "Hiperconvergência", "Virtualização"],
  },
  {
    icon: "ri-hard-drive-2-line",
    title: "Storage e Proteção de Dados",
    description:
      "Armazenamento corporativo com foco em desempenho, segurança, escalabilidade e alta disponibilidade, ideal para sustentar aplicações críticas e ambientes de missão crítica.",
    tags: ["Storage", "Alta disponibilidade", "Escalabilidade"],
  },
  {
    icon: "ri-save-3-line",
    title: "Backup e Recuperação",
    description:
      "Proteção completa de dados com backup local, em nuvem e imutável, garantindo integridade, disponibilidade e recuperação diante de falhas, perdas acidentais ou ataques de ransomware.",
    tags: ["Backup", "Imutável", "Disaster Recovery"],
  },
  {
    icon: "ri-cloud-line",
    title: "Cloud Pública e Cloud Privada",
    description:
      "Nuvem pública e hospedagem de VMs em cloud privada com foco em flexibilidade, segurança, desempenho, disponibilidade e otimização da operação de TI.",
    tags: ["Cloud", "VMs", "Alta disponibilidade"],
  },
  {
    icon: "ri-shield-keyhole-line",
    title: "Cibersegurança e LGPD",
    description:
      "Portfólio abrangente de segurança cibernética e adequação à LGPD: firewall, EDR, XDR, MDR, NAC, ZTNA, SIEM, SOAR, SASE e programas de conscientização para proteção dos ativos digitais.",
    tags: ["Segurança", "LGPD", "Compliance"],
  },
  {
    icon: "ri-router-line",
    title: "Conectividade e Redes",
    description:
      "Redes corporativas com switches, Wi-Fi e arquitetura de alto desempenho, garantindo estabilidade, eficiência e aderência às necessidades específicas de cada operação.",
    tags: ["Switches", "Wi-Fi", "Conectividade"],
  },
  {
    icon: "ri-radar-line",
    title: "NG-SOC e Resposta a Incidentes",
    description:
      "SOC as a Service com monitoramento, detecção e resposta a incidentes de segurança, combinando especialistas, automação e inteligência artificial para atuação proativa e rápida resposta a ameaças.",
    tags: ["SOC", "Detecção", "Resposta"],
  },
  {
    icon: "ri-customer-service-2-line",
    title: "Suporte, Service Desk e NOC",
    description:
      "Suporte técnico especializado com gestão de chamados, inventário, monitoramento e operação contínua via GLPI, Zabbix e Grafana, com opções remotas, presenciais, outsourcing e 24x7.",
    tags: ["NOC", "Service Desk", "24x7"],
  },
  {
    icon: "ri-brain-line",
    title: "Inteligência Artificial",
    description:
      "Soluções de IA aplicadas à transformação digital: IA generativa, IA agêntica, automação inteligente, visão computacional e casos de uso voltados a eficiência, inovação e geração de valor.",
    tags: ["IA Generativa", "Agentic AI", "Automação"],
  },
  {
    icon: "ri-settings-4-line",
    title: "Soluções Personalizadas",
    description:
      "Projetos sob medida para demandas complexas, integrando banco de dados, BI, IA, DevOps, DevSecOps, cloud e infraestrutura híbrida, com atendimento consultivo e acompanhamento ponta a ponta.",
    tags: ["Projetos sob medida", "Integração", "Consultoria"],
  },
];

export default function ServicesSection() {
  const handleNav = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section id="solucoes" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div
            className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest mb-4"
            style={{ color: "#4C86C2" }}
          >
            <div
              className="w-6 h-px"
              style={{ background: "linear-gradient(to right, #62A9E0, #4C86C2)" }}
            ></div>
            O que oferecemos
            <div
              className="w-6 h-px"
              style={{ background: "linear-gradient(to right, #62A9E0, #4C86C2)" }}
            ></div>
          </div>
          <h2 className="text-4xl font-black text-[#000000] mb-4">
            Nossas <span className="solus-gradient-text">Soluções</span>
          </h2>
          <p className="text-[#000000]/55 max-w-2xl mx-auto text-sm leading-relaxed">
            Portfólio completo de soluções e serviços de TI para empresas e órgãos públicos, da
            consultoria estratégica à sustentação operacional.
          </p>
        </div>

        {/* Cards grid — 2 rows of 5 on xl, 3 cols on lg, 2 cols on md */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-5">
          {services.map((service) => (
            <ServiceCard key={service.title} service={service} />
          ))}
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-12">
          <button
            onClick={() => handleNav("#contato")}
            className="px-8 py-3 solus-btn-primary font-semibold rounded-md text-sm cursor-pointer whitespace-nowrap"
          >
            Solicitar proposta
          </button>
          <a
            href="https://www.dropbox.com/scl/fi/jlnrhzizi96z9qkkaaz8x/ATA-SOLUS-TREAP-2026-1-1.pdf?rlkey=6pzpjngquhnii09rrqp007k0q&dl=0"
            target="_blank"
            rel="noopener noreferrer"
            className="px-8 py-3 solus-btn-secondary font-semibold rounded-md text-sm cursor-pointer whitespace-nowrap inline-flex items-center gap-2"
          >
            <i className="ri-file-text-line" />
            Atas de Registro de Preços
          </a>
        </div>
      </div>
    </section>
  );
}

interface ServiceCardProps {
  service: {
    icon: string;
    title: string;
    description: string;
    tags: string[];
  };
}

function ServiceCard({ service }: ServiceCardProps) {
  return (
    <div
      className="group bg-white rounded-lg p-6 hover:translate-y-[-4px] transition-all duration-300 cursor-default flex flex-col"
      style={{ border: "1px solid rgba(98,169,224,0.15)" }}
      onMouseEnter={(e) => {
        (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(98,169,224,0.5)";
      }}
      onMouseLeave={(e) => {
        (e.currentTarget as HTMLDivElement).style.borderColor = "rgba(98,169,224,0.15)";
      }}
    >
      {/* Icon */}
      <IconBox icon={service.icon} />

      <h3 className="text-sm font-bold text-[#000000] mb-2 leading-snug mt-4">
        {service.title}
      </h3>
      <p className="text-xs text-[#000000]/55 leading-relaxed mb-4 flex-1">
        {service.description}
      </p>
      <div className="flex flex-wrap gap-1.5">
        {service.tags.map((tag) => (
          <span
            key={tag}
            className="text-[11px] px-2 py-0.5 rounded-full font-medium whitespace-nowrap"
            style={{ background: "rgba(98,169,224,0.1)", color: "#4C86C2" }}
          >
            {tag}
          </span>
        ))}
      </div>
    </div>
  );
}

function IconBox({ icon }: { icon: string }) {
  return (
    <div
      className="w-10 h-10 flex items-center justify-center rounded-lg transition-all duration-300 group-hover:[background:linear-gradient(135deg,#62A9E0,#4C86C2)] group-hover:text-white"
      style={{ background: "rgba(98,169,224,0.1)", color: "#4C86C2" }}
    >
      <i className={`${icon} text-lg`}></i>
    </div>
  );
}
